import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useContext } from 'react';
import { AuthContext } from '../../contexts';
import { Page } from '../../design';
import { useRequester } from '../../hooks';
import { StatisticResource } from '../../resources';
import { Statistic } from '../../resources/StatisticResource';
import LineChartWithAPI from './LineChartWithAPI';

function DashboardPage() {
  const { user } = useContext(AuthContext);

  const scoreApi = useRequester<StatisticResource[]>({
    onSubmit: (q) => StatisticResource.fetchStatistic(Statistic.EikenScores, q),
    onError: console.log,
  });

  const studyTimeApi = useRequester<StatisticResource[]>({
    onSubmit: (q) => StatisticResource.fetchStatistic(Statistic.EikenStudyTimes, q),
    onError: console.log,
  });

  return (
    <Page>
      <Page.Header>
        <Box className="flex flex-col h-full">
          <Typography variant="body1" color="text.secondary" sx={{ mt: 8 }}>
            👋 Hey, {user?.data.firstName}!
          </Typography>
          <Typography variant="h1">Welcome to your student dashboard</Typography>
          <Box className="flex-grow"></Box>
          <Box>
            <Tabs value="all">
              <Tab label="All Students" value="all" />
            </Tabs>
          </Box>
        </Box>
      </Page.Header>
      <Page.Content>
        <Box sx={{ mt: 5 }}>
          <LineChartWithAPI
            configs={[
              {
                title: 'Scores',
                statistic: Statistic.EikenScores,
                toDatapoint: (item) => ({
                  x: StatisticResource.parseId(item.data.id).startDate.toDate().getTime(),
                  y: item.data.count > 0 ? item.data.sum : null,
                }),
                toAverage: (values) => {
                  const validValues = values.filter((item) => item.data.count > 0);
                  if (validValues.length === 0) return 'N/A';
                  const avg = validValues.reduce((acc, item) => acc + item.data.sum, 0) / validValues.length;
                  return avg.toFixed(2);
                },
                fetcher: scoreApi,
                margin: { left: 28, right: 32, top: 16, bottom: 30 },
              },
              {
                title: 'Study Times',
                statistic: Statistic.EikenStudyTimes,
                toDatapoint: (item) => ({
                  x: StatisticResource.parseId(item.data.id).startDate.toDate().getTime(),
                  y: Math.round(item.data.sum / 60),
                }),
                toAverage: (values) => {
                  const avg =
                    values.reduce((acc, item) => acc + item.data.sum, 0) / values.length / 60;

                  return avg.toFixed(0) + ' min';
                },
                fetcher: studyTimeApi,
                margin: { left: 28, right: 56, top: 16, bottom: 30 },
              },
            ]}
          />
        </Box>
      </Page.Content>
    </Page>
  );
}

export default DashboardPage;
